import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=0fa27224&scoped=true&lang=pug"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa27224",
  null
  
)

export default component.exports